module.exports = __webpack_public_path__ + "static/media/avatar.1acf810c.png";